var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3685)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 22,
    r: 22,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1129 34V14.9091H20.4077V34H15.1129ZM17.7727 12.4482C16.9856 12.4482 16.3103 12.1871 15.7468 11.6651C15.1916 11.1348 14.9141 10.5009 14.9141 9.76349C14.9141 9.03433 15.1916 8.40874 15.7468 7.88672C16.3103 7.35641 16.9856 7.09126 17.7727 7.09126C18.5599 7.09126 19.2311 7.35641 19.7862 7.88672C20.3497 8.40874 20.6314 9.03433 20.6314 9.76349C20.6314 10.5009 20.3497 11.1348 19.7862 11.6651C19.2311 12.1871 18.5599 12.4482 17.7727 12.4482ZM29.9438 22.9631V34H24.6491V14.9091H29.6952V18.2773H29.9189C30.3415 17.167 31.05 16.2887 32.0443 15.6424C33.0386 14.9878 34.2442 14.6605 35.6611 14.6605C36.9869 14.6605 38.1428 14.9505 39.1288 15.5305C40.1149 16.1106 40.8813 16.9392 41.4282 18.0163C41.9751 19.0852 42.2485 20.3613 42.2485 21.8445V34H36.9537V22.7891C36.962 21.6207 36.6637 20.7093 36.0589 20.0547C35.454 19.3918 34.6212 19.0604 33.5606 19.0604C32.848 19.0604 32.2183 19.2137 31.6714 19.5202C31.1328 19.8268 30.7103 20.2743 30.4037 20.8626C30.1054 21.4426 29.9521 22.1428 29.9438 22.9631Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3685",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3685",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.dd423cef632b6fd1ad769257d93bb586.svg";
export { ForwardRef as ReactComponent };